import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const orderByDescending = (source, keySelector, comparer) => {
    return OrderedAsyncEnumerable.generate(source, keySelector, false, comparer);
};
